
































































































































































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import { add, bignumber, subtract, multiply } from 'mathjs'
import { zeroUnit } from '@/web-task/utils'
import { hasValue, debounce } from '@/utils/util'

const compulsoryDebounce = debounce(300)
const commercialDebounce = debounce(300)

@Component({})
export default class FeeRow extends Vue {
	private feeRequired = false

	@Prop({ default: '天' })
	private unitDesc!: string

	@Prop({ default: false })
	private isReadonly!: boolean

	@Prop()
	private config!: any

	@Prop()
	private spans!: any

	@Prop()
	private index!: any

	@Prop()
	private form!: any

	@Prop({ default: () => ({}) })
	private initial!: any

	@Prop({ default: '' })
	private initialRate!: any

	@Prop({ default: '' })
	private initialDuration!: any

	@Prop({ default: false })
	private itemRequired!: boolean

	@Watch('initialRate')
	private onRatioChange() {
		this.form.setFieldsValue({
			[`${this.config.name}.rate`]: this.initialRate,
		})
	}

	@Watch('initialDuration')
	private onDurationChange() {
		this.form.setFieldsValue({
			[`${this.config.name}.duration`]: this.initialDuration,
		})
	}

	private hasValue(val: any) {
		return hasValue(val)
	}

	private zeroUnit(value: any, unit: string = '元') {
		return zeroUnit(value, unit)
	}

	private triggerSumValidator(rule: any, value: any, cb: any) {
		if (this.config.formula) {
			this.form.validateFields([`${this.config.name}.commercial`])
		}
		return cb()
	}

	private sumValidator(rule: any, value: any, cb: any) {
		if (this.config.formula) {
			let res: any = -1
			let ratio: any
			let prefix = this.config.name
			let dailyCost: any = this.form.getFieldValue(`${prefix}.unit`)
			let dayNum: any = this.form.getFieldValue(`${prefix}.duration`)
			if (this.config.hasRatio) {
				ratio = this.form.getFieldValue(`${prefix}.rate`)
				if (dailyCost && dayNum && ratio) {
					res = multiply(
						multiply(bignumber(dailyCost), bignumber(dayNum)),
						bignumber(ratio)
					)
				}
			} else {
				if (dailyCost && dayNum) {
					res = multiply(bignumber(dailyCost), bignumber(dayNum))
				}
			}
			if (res !== -1) {
				let compulsory =
					parseFloat(this.form.getFieldValue(`${prefix}.compulsory`)) || 0
				let commercial =
					parseFloat(this.form.getFieldValue(`${prefix}.commercial`)) || 0
				if (
					compulsory > res ||
					commercial > res ||
					(compulsory &&
						commercial &&
						subtract(add(bignumber(compulsory), bignumber(commercial)), res) >
							0)
				) {
					return cb(
						new Error('交强险对应金额+商业险对应金额不能超过公式计算的金额')
					)
				}
			}
		}
		return cb()
	}

	private setFeeRequired() {
		let res =
			hasValue(this.form.getFieldValue(`${this.config.name}.compulsory`)) ||
			hasValue(this.form.getFieldValue(`${this.config.name}.commercial`))
		this.feeRequired = !!res
		this.$emit('feeChange', !!res)
	}

	private onCompulsoryChange() {
		compulsoryDebounce(() => {
			this.setFeeRequired()
			this.$emit('compulsoryChange')
		})
	}

	private onCommercialChange() {
		commercialDebounce(() => {
			this.setFeeRequired()
			this.$emit('commercialChange')
		})
	}

	private created() {
		this.setFeeRequired()
	}
}
